module.exports = __webpack_public_path__ + "static/media/card-logo-amex.e90e5a7b.svg";